import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import { DailyRegistration } from '../../types/dashboard';

interface Props {
  registrations: DailyRegistration[];
}

const UserRegistrationChart: React.FC<Props> = ({ registrations }) => {
  const data = registrations.map(reg => ({
    date: new Date(reg.date).toLocaleDateString(),
    count: reg.count
  }));

  return (
    <div className="stats-card hover:border-primary-500/20 group">
      <div className="p-6 space-y-4">
        <h2 className="text-xl font-medium text-gray-900 dark:text-white">
          Daily User Registrations
        </h2>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis 
                dataKey="date" 
                angle={-45}
                textAnchor="end"
                height={70}
                interval={0}
                className="text-xs"
              />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="count" stroke="#6366f1" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default UserRegistrationChart;
